module.exports = __webpack_public_path__ + "static/img/banner0.3fba7134.png";